import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { AnnualMinimumDetails } from '../../../../../../models/transactions/annual-minimum-details';

@Component({
  selector: 'app-vb-payments-min-calculation-age',
  templateUrl: './vb-payments-min-calculation-age.component.html',
  styleUrls: ['./vb-payments-min-calculation-age.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VbPaymentsMinCalculationAgeComponent {
  @Input({ required: true }) minimumDetails!: AnnualMinimumDetails;
}
